module.exports = __webpack_public_path__ + "img/4takes.7be42210.jpg";